import { FC } from 'react';
import { Card, CardHeader } from '../../../components/Card';
import { useHistory } from '../../../services/history';
import { formatDuration } from '../../../utils/formatDuration';
import { DataList } from '../../../components/DataList';
import { formatMileage } from '../../../utils/formatMileage';
import { FormattedMessage } from 'react-intl';

interface SummaryProps {}

export const Summary: FC<SummaryProps> = () => {
  const data = useHistory();

  if (!data) {
    return null;
  }

  const summary = data.summary;

  return (
    <Card>
      <CardHeader>
        <FormattedMessage id="Summary" />
      </CardHeader>
      <DataList>
        {!!summary.distance && (
          <>
            <FormattedMessage tagName="dt" id="Summary.Distance" />
            <dd>{formatMileage(summary.distance)}</dd>
          </>
        )}
        {!!summary.privateTypeDistance && (
          <>
            <FormattedMessage tagName="dt" id="Summary.Distance.Private" />
            <dd>{formatMileage(summary.privateTypeDistance)}</dd>
          </>
        )}

        {!!summary.businessTypeDistance && (
          <>
            <FormattedMessage tagName="dt" id="Summary.Distance.Business" />
            <dd>{formatMileage(summary.businessTypeDistance)}</dd>
          </>
        )}
        {!!summary.workTypeDistance && (
          <>
            <FormattedMessage tagName="dt" id="Summary.Distance.Work" />
            <dd>{formatMileage(summary.workTypeDistance)}</dd>
          </>
        )}
        {!!summary.noneTypeDistance && (
          <>
            <FormattedMessage tagName="dt" id="Summary.Distance.None" />
            <dd>{formatMileage(summary.noneTypeDistance)}</dd>
          </>
        )}
        <FormattedMessage tagName="dt" id="Summary.Time.Work" />
        <dd>{formatDuration(summary.drivingDuration)}</dd>

        <FormattedMessage tagName="dt" id="Summary.Time.Stop" />
        <dd>{formatDuration(summary.stopDurationWithoutMidnightTillStart)}</dd>
      </DataList>
    </Card>
  );
};
